import localAxios from '../localAxios';
import { createTeamInviteUrl } from './urls';

interface CreateInviteResponse {
  failed: Array<string>;
  succeed: Array<string>;
}

interface TeamInviteParams {
  emails: Array<string>;
  role: number;
  teamId: string;
}

export async function createTeamInvite({
  teamId,
  emails,
  role,
}: TeamInviteParams) {
  const url = createTeamInviteUrl(teamId);
  const result = await localAxios.post<CreateInviteResponse>(url.href, {
    emails: emails,
    role: role,
  });
  return result.data;
}
